import { render, staticRenderFns } from "./PerformanceTargetsTabDefinitions.vue?vue&type=template&id=ba3e9e00"
import script from "./PerformanceTargetsTabDefinitions.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetsTabDefinitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports